import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#press-detail')

if (mountEl) {
    const props = {
        pressId: parseInt(mountEl.dataset.pressId),
        username: mountEl.dataset.username || null,
    }

    createApp(App, props).mount('#press-detail')
}
